import React, { useContext } from "react";
import {
  pickNotDeprecated,
  useActiveAuthProvider,
  useGetIdentity,
  HttpError,
} from "@refinedev/core";
import { Layout as AntdLayout, Typography, Avatar,
         Space, theme, Switch,
  } from "antd";
import type { RefineThemedLayoutV2HeaderProps } from "@refinedev/antd";
import { useForm, Edit } from "@refinedev/antd";
import { ColorModeContext } from "../../contexts/color-mode";

const { Text } = Typography;
const { useToken } = theme;

export const ThemedHeaderV2: React.FC<RefineThemedLayoutV2HeaderProps> = ({
  sticky,
}) => {
  const { token } = useToken();
  const { mode, setMode } = useContext(ColorModeContext);

  const authProvider = useActiveAuthProvider();
  const { data: user } = useGetIdentity({
    v3LegacyAuthProviderCompatible: Boolean(authProvider?.isLegacy),
  });

  const shouldRenderHeader = user && (user.name || user.avatar);


  if (!shouldRenderHeader) {
    return null;
  }

  const headerStyles: React.CSSProperties = {
    backgroundColor: token.colorBgElevated,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "0px 24px",
    height: "64px",
    marginBottom: "20px"
  };

  if (pickNotDeprecated(sticky)) {
    headerStyles.position = "sticky";
    headerStyles.top = 0;
    headerStyles.zIndex = 1;
  }

  return (
    <AntdLayout.Header style={headerStyles}>
      <Space>
      <Switch
          checkedChildren="🌛"
          unCheckedChildren="🔆"
          onChange={() => setMode(mode === "light" ? "dark" : "light")}
          defaultChecked={mode === "dark"}
        />
        <Space size="middle">
          <div style={{display: "flex", marginBottom: 10}}>
            <div style={{ display: "flex", flexDirection: "column", }}>
              {user?.name && <Text strong>{user.name}</Text>}
              {user?.email && <Text type="secondary">{user.email}</Text>}
            </div>
            {user?.avatar && <Avatar src={user?.avatar} alt={user?.name} />}
          </div>
        </Space>
      </Space>
    </AntdLayout.Header>
  );
};
